// Definitions of our "Life Moments Framework" terminology that are re-used
// across different AI prompts, and potentially in other places of our system.

import { VIDEO_INTENTS } from 'utils/intents';

export const DEF_EMOTIONAL_MECHANISMS = 'What is shifting at the emotional, felt-experience level when practicing the exercise(s).';

export const DEF_INTENDED_SHIFT = 'The presumed state of a person prior to performing the exercises, and their intended, target state after performing the exercises.';

export const DEF_INTENT = `The main fitness goal or outcome that the video is designed to help the viewer achieve. It describes the central purpose of the exercise session, such as ${VIDEO_INTENTS.map((value) => `"${value}"`).join(', ')}. The primary intent should reflect the workout’s dominant objective rather than individual exercises, secondary benefits, or incidental movements.`;

export const DEF_MODALITIES = 'Included kinds of wellbeing exercises and activities.';

export const DEF_NEUROLOGICAL_MECHANISMS = 'What is happening in the brain and nervous system when performing the exercise(s).';

export const DEF_PHYSICAL_MECHANISMS = 'What is changing at the body level when performing the exercise(s).';

export const DEF_TRANSFORMATION_STAGES = 'A "transformation stage" is a specific set of emotional, neurological, and/or physical effects caused by a certain kind of wellbeing exercises in the person executing (experiencing, practicing) them.';
